import { postRequest } from '../../../shared/utils';
import { GridFilterModel, JSONValue } from '../../../shared/types';

type NpiSteeringIdRow = {
  id1: number;
};

type GetBulkUpdateNpiSteeringIdsParams = {
  screenGridId: number;
  schema: string;
  table: string;
  filterModel?: GridFilterModel;
};

export async function getBulkUpdateNpiSteeringIdsService({
  screenGridId,
  schema,
  table,
  filterModel,
}: GetBulkUpdateNpiSteeringIdsParams) {
  const body = {
    columns: ['id1'],
    screenGridId,
    schema,
    table,
    filterModel,
    orderCol: 'id1',
    order: 'desc',
  };

  const { data, errors } = await postRequest('/api/records', body as unknown as JSONValue);

  if (errors) {
    return { errors };
  }

  const responseKey = `${schema}_${table}`;
  const rows: NpiSteeringIdRow[] = data?.[responseKey] ?? [];
  const id1List = rows.map((row) => row.id1).filter((id1) => Number.isFinite(id1));

  return {
    data,
    rows,
    id1List,
  };
}
